/**
 * Created by ricardocabret on 8/18/16.
 */

angular.module('findawayPlayerProvider.model', [

    //This Provider handles all Findaway Audiobook and MP3 Audiobook Samples

])
    .service('FindawayPlayer', ['WS', 'AccountModel', function (WS, AccountModel) {
        var model = this;

        model.initFindawayProvider = async (eventCallbacksObj) => {
            if (!AccountModel.isUserLoggedIn) {
                return;
            }
            try {
                const response = await model._createFindawaySession();
                if (response.responseText === "SUCCESS") {
                    model.sessionKey = response.sessionKey;
                    model._setupFindawayPlayer(model.sessionKey, eventCallbacksObj);
                }
            } catch (err) {
                console.error("Unable to create findaway session. Error: ", err);
            }
        };

        model.initSamplePlayer = function (eventCallbacksObj) {
            model._setupSamplePlayer(eventCallbacksObj);
        };

        model._createFindawaySession = function () {
            return WS.callServer('account/createFindawaySession', {});
        };

        model._setupFindawayPlayer = function (sessionKey, eventCallbacksObj) {
            findaway.ready(function () {
                model.myAccount = new findaway.Account(AccountModel.userDetails.snid);
                model.player = new findaway.Player(model.myAccount);

                model.myAccount.on('load:success', function (account) {
                }).load();

                //event Callbacks coming from Player Model

                model.player.on('load:success', function (_player) {
                    model.player.trigger('play');
                });

                model.player.on('load:error', function (error) {
                    eventCallbacksObj.handleLoadError(error);
                });

                model.player.on('timeChanged', function (time) {
                    model.findawayPlayerCurrentTime = time;
                    eventCallbacksObj.handleTimeChanged(time);
                });

                model.player.on('trackChanged', function (track) {
                    eventCallbacksObj.handleTrackChanged(track);
                });

                model.player.on('bookCompleted', function (_player) {
                    _player.trigger('unload');
                });

                model.player.on('playback:paused', function (_player) {
                    eventCallbacksObj.handlePaused();
                });

                model.player.on('unloaded', function (_player) {
                    //Do something for unloaded
                });

            }).init({
                session_key: sessionKey,
                consumer_key: AccountModel.userDetails.snid,
                useHTML5Audio: true,
                debug: false
            });
        };

        model._setupSamplePlayer = function (eventCallbacksObj, callbackFunc) {
            try {
                model.samplePlayer = new Audio();
            } catch (e) {
                return;
            }

            model.samplePlayer.addEventListener("canplaythrough", function () {
                eventCallbacksObj.handleOnLoad(model.samplePlayer)
            }, false);

            model.samplePlayer.addEventListener("timeupdate",
                function () {
                    eventCallbacksObj.handleTimeChanged(model.samplePlayer.currentTime * 1000, true)
                }, false);

            model.samplePlayer.addEventListener('ended', function () {
                eventCallbacksObj.handleOnEnd();
                model.samplePlayer.currentTime = 0;
            });

            if (callbackFunc) {
                callbackFunc();
            }
        };

        model.play = function (libraryAudiobook, isSample, trackObj, position, callbackFunc) {
            // This function handles first time play
            if (isSample) {
                model._playSample(libraryAudiobook);
            } else {
                model._playAudiobook(libraryAudiobook.audiobook, trackObj.index, position, callbackFunc);
            }
        };

        model.resumePlay = function () {
            // This function handles resume play
            if (model.isSample) {
                //Sample Play
                model.samplePlayer.play();
            } else {
                //Findaway Player play
                model.player.trigger('play');
            }
        };

        model.pause = function () {
            if (model.isSample) {
                model.samplePlayer.pause();
            } else {
                model.player.trigger('pause');
            }
        };

        model._playSample = function (audiobook) {
            model.isSample = true;
            if (AccountModel.isUserLoggedIn) {
                model.player.trigger('unload');
            }

            if (!model.samplePlayer) {
                return;
            }

            if (model.samplePlayer && !model.samplePlayer.paused) {
                model.samplePlayer.pause();
                model.samplePlayer.currentTime = 0;
            }

            model.samplePlayer.src = audiobook.providerSampleUrl;
            model.samplePlayer.play();
        };

        model._playAudiobook = function (audiobook, track, position, callbackFunc) {
            model.isSample = false;
            //Load Findaway Audiobook
            if (audiobook != null) {
                var findawayBook = new findaway.Audiobook(audiobook.providerAudiobookId);
                findawayBook.on('load:success', function (findawayAudiobook) {
                    model.player.load({
                        book: findawayAudiobook,
                        track: track,
                        position: position
                    });
                }).load();

                if (callbackFunc) {
                    callbackFunc();
                }
            }
        };

        model.getCurrentTime = function () {
            if (model.isSample && model.samplePlayer) {
                return model.samplePlayer.currentTime * 1000;
            } else {
                return model.findawayPlayerCurrentTime;
            }
        };

        model.getChapterDuration = function () {
            if (model.isSample && model.samplePlayer) {
                return model.samplePlayer.duration * 1000;
            } else {
                //findaway Chapter Duration;
            }
        };

        model.skipToTrack = function (libraryAudiobook, trackObj, callbackFunc) {
            model._playAudiobook(libraryAudiobook.audiobook, trackObj.index, 0, callbackFunc);
        };

        model.seekTo = function (time) {
            if (model.isSample) {
                model.samplePlayer.currentTime = time / 1000;
            } else {
                model.player.trigger('seek-to', time);
            }
        };

        model.setVolume = function (value, isSample) {
            if (isSample) {
                model.samplePlayer.volume = value / 100;
            } else {
                model.player.trigger('set-volume', value);
            }
        };

        model.mutePlayer = function () {
            if (model.isSample) {
                model.samplePlayer.volume = 0;
            } else {
                model.player.trigger('set-volume', 0);
            }
        };

    }]);
